import { IconSvg } from "@graphcommerce/next-ui";
import { Box, FormControl, MenuItem, Select, useMediaQuery, useTheme } from "@mui/material";
import { useState } from "react";
import iconTrash from './delete.svg';

export default function ProductLayer(props) {
  const { products, items, setItems, layer, item, initialQty } = props;

  const t = useTheme();
  const inMobile = useMediaQuery(t.breakpoints.down('md'));

  const [sku, setSku] = useState(item?.sku);
  const [quantity, setQuantity] = useState(initialQty);

  function handleChange(e) {
    const obj = products.find((o) => o.sku === e.target.value);
    const inItems = items.filter((o) => o.layer != layer);
    setItems([...inItems, { layer: layer, quantity: quantity, obj: { ...obj } }]);
    setSku(e.target.value);
  }

  function remove() {
    const obj = items.filter((o) => o.layer != layer);
    setItems([...obj]);
  }

  return (
    <>
      <Box sx={(theme) => ({
        display: 'flex',
        flexDirection: 'row',
        flexWrap: 'wrap',
        mb: 2,
        maxWidth: '100%',
        [theme.breakpoints.down('md')]: {
          mb: 5,
          border: 1,
          borderRadius: '8px',
          borderColor: theme.palette.grey[500],
          padding: 2
        }
      })}>
        <Box
          sx={{
          }}>
          <FormControl>
            <Select
              labelId="demo-simple-select-helper-label"
              id="demo-simple-select-helper"
              value={sku}
              onChange={handleChange}
              MenuProps={{
                style: { maxHeight: 250 }
              }}
              sx={(theme) => ({
                width: 250,
                [theme.breakpoints.down('sm')]: {
                  mb: 2,
                },
                [theme.breakpoints.down('md')]: {
                  mr: 2,
                },
              })}
            >
              {products.map((product) => (
                <MenuItem
                  value={product.sku}
                >{product.name}</MenuItem>
              ))}
            </Select>
          </FormControl>
        </Box>
        {!inMobile && <Box
          sx={{
            marginY: 'auto',
            marginX: 5
          }}>
          X
        </Box>}
        <Box>
          <FormControl>
            <Select
              labelId="demo-simple-select-helper-label"
              id="demo-simple-select-helper"
              value={quantity}
              onChange={(e) => {
                setQuantity(e.target.value);
                const obj = products.find((o) => o.sku === sku);
                const inItems = items.filter((o) => o.layer != layer);
                setItems([...inItems, { layer: layer, quantity: e.target.value, obj: { ...obj } }]);
              }}
              MenuProps={{
                style: { maxHeight: 250 }
              }}
              sx={{
                width: 200
              }}
            >
              {item?.price_tiers?.map((i) => (
                <MenuItem value={i.quantity}>{i.quantity.toLocaleString(undefined, { maximumFractionDigits: 0 })} chips</MenuItem>
              ))}
            </Select>
          </FormControl>
        </Box>
        <Box
          onClick={remove}
          sx={{
            display: 'flex',
            alignItems: 'center'
          }}>
          <IconSvg src={iconTrash}
            sx={{
              width: 30,
              height: 30,
              marginLeft: 2,
              cursor: 'pointer'
            }} />
        </Box>
      </Box >
    </>
  );
}